import { render } from "./DatosEmpresaDatosDatos.vue?vue&type=template&id=7b26658d"
import script from "./DatosEmpresaDatosDatos.vue?vue&type=script&lang=js"
export * from "./DatosEmpresaDatosDatos.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__